import { IconButton, SvgIcon } from "@mui/material";
import GlobalFunctionHelper from "../../Utilities/Helpers/GlobalFunctionHelper";
import { ErrorOutlinedIcon } from "../../Utilities/Helpers/IconHelper";
import CustomTooltip from "./CustomTooltip";
import styled from "styled-components";

const ExclamationBtn = styled(IconButton)`
    width: 14px;
    height: 14px;
    padding: 0px !important;
    margin: 0px 0px 0px 10px !important;
    line-height: 1;
    align-self: flex-start;
`

const ExclamationIcon = styled(SvgIcon)`
        width: 16px;
        height: 16px;
        fill: var(--subTextPrimaryColor);
`

const CustomExclamationHover = (props: any) => {
    return <CustomTooltip {...{
        tooltipName: props.hoverText,
        placement: "top",
        tooltipContent: <ExclamationBtn size="small" className="exclamationHoverItemDisplayBtn">
            <ErrorOutlinedIcon style={{ width: '16px', height: '16px', fill: 'var(--subTextPrimaryColor)' }} />
        </ExclamationBtn>,
    }} />
}

export default CustomExclamationHover;